//Node Modules
import axios from 'axios'

//Types
import { CDCInfo, BaseCDCInfo, DocsetCollection, CDCVersion, DefaultContext } from 'types/cdc'
import { TOC, Node } from 'types/toc'
import { Default } from 'types/context'
import { SearchResults } from 'types/search'
import { Format} from 'types/format';

//Util
/* import {isAdvSearch} from 'util/search' */

const BASE_URL = '/collections'

export function info(alias: string, cfr: string): Promise<BaseCDCInfo> {
  return axios.get<BaseCDCInfo>(`${BASE_URL}/${alias}/${cfr}`)
    .then(result => result.data)
}

export function cdcMatch(cdcId: string, cdcVersion: string, docsetId: string, docsetVersion:string): Promise<BaseCDCInfo> {
  return axios.get<BaseCDCInfo>(`${BASE_URL}/${cdcId}/${cdcVersion}/docsets/${docsetId}/${docsetVersion}/primaryCdcMatch`)
    .then(result => result.data)
}

export function downloadInfo(lang: string, softwareId: string, softwareVersion: string, softwareSpecialConfig?:string): Promise<BaseCDCInfo> {
  return axios.get<BaseCDCInfo>(`${BASE_URL}?softwareName=${softwareId}&softwareVersion=${softwareVersion}${softwareSpecialConfig ? '&softwareContext='+softwareSpecialConfig : ''}`, { headers: {'Accept-Language': lang}})
    .then(result => result.data)
}

export function toc(alias: string, cfr: string, requestor: string | null): Promise<Node[]> {
  return axios.get<TOC>(`${BASE_URL}/${alias}/${cfr}/toc${requestor ? '?requestorId='+requestor : ''}`)
    .then(result => result.data.toc)
}

export function versions(alias: string): Promise<CDCVersion[]> {
  return axios.get<CDCVersion[]>(`${BASE_URL}/${alias}/versions`)
    .then(result => result.data)
}

export function cdcs(alias: string, cfr: string, requestor: string | null): Promise<CDCInfo[]> {
  return axios.get<{ cdcs: CDCInfo[]}>(`${BASE_URL}/${alias}/${cfr}/collections${requestor ? '?requestorId='+requestor : ''}`)
    .then(result => result.data.cdcs)
}

export function defaultContext(alias: string, cfr: string): Promise<DefaultContext> {
  return axios.get<DefaultContext>(`${BASE_URL}/${alias}/${cfr}/contexts?default=true`)
    .then(result => result.data)
}

export function home(alias: string, cfr: string): Promise<Default> {
  return axios.get<Default>(
    `${BASE_URL}/${alias}/${cfr}/contexts?default`
  ).then(result => result.data)
}

export function search(alias: string, cfr: string, query: Object): Promise<SearchResults> {
  return axios.get<SearchResults>(
    `${BASE_URL}/${alias}/${cfr}/search`,
    {
      params: query
    }
  ).then((result:any) => result.data.response as SearchResults)
}

export function docsetCollection(alias: string, cfr: string): Promise<DocsetCollection> {
  return axios.get<DocsetCollection>(
    `${BASE_URL}/${alias}/${cfr}/docsets`
  ).then((result:any) =>{
    return result.data as DocsetCollection
  })
}

export function formatAvailable(source: any, alias: string, cfr: string, docset: string, format: Format, lang: string,  casExt?: string): Promise<string> {
  let url = `${BASE_URL}/${alias}/${cfr}/docsets/${docset}/content/${docset}${casExt ? '-'+casExt : ''}.${format}`
  return axios.head(url, { cancelToken: source.token }).then(() => {
    return `/api${url}?locale=${lang}`
  })
}

export function casFormatAvailable(alias: string, cfr: string, docset:string, fileName: string, format: Format, lang: string,  casExt?: string): Promise<string> {
  let url = `${BASE_URL}/${alias}/${cfr}/docsets/${docset}/content/${fileName}${casExt ? '-'+casExt : ''}.${format}`
  return axios.head(url).then(() => `/api${url}?locale=${lang}`)
}